import React, { FC } from 'react';
import type { CustomCategoryProps } from './CustomCategory.types';
import { getCustomCategoryComponent } from './helpers';

export const CustomCategory: FC<CustomCategoryProps> = ({ category }) => {
  const Component = getCustomCategoryComponent(category);

  if (!Component) {
    return null;
  }

  return <Component category={category} />;
};
